import { ADDABLE_NODE_TEMPLATES } from "./nodeTemplates";

interface PaletteProps {
  onAddNode: (type: string, config: unknown) => void;
}

/**
 * Lists every addable node type (nodeTemplates.ts); clicking one appends a
 * new, disconnected node to the canvas with a schema-shaped default
 * config, selected immediately so the Inspector opens on it. `start` and
 * `amd_gate` are deliberately absent — see nodeTemplates.ts's own comment
 * for why.
 */
export function Palette({ onAddNode }: PaletteProps) {
  return (
    <aside className="card palette" aria-labelledby="palette-heading">
      <h2 id="palette-heading">Add node</h2>
      <ul className="palette__list">
        {ADDABLE_NODE_TEMPLATES.map((template) => (
          <li key={template.type}>
            <button type="button" onClick={() => onAddNode(template.type, template.defaultConfig())}>
              + {template.label}
            </button>
          </li>
        ))}
      </ul>
      <p className="card__note">A new node starts disconnected — connecting it is a later slice.</p>
    </aside>
  );
}
